module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ca-AD.json
// module id = 1464
// module chunks = 22